<template>
  <div class="container">
    <v-row>
      <v-col>
      <v-data-table
        :headers="headers2"
        :items="items2"
        class="elevation-1"
        disable-pagination
        disable-filtering
        hide-default-footer
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :custom-sort="customSort"
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Επόμενες τιμολογήσεις</v-toolbar-title>
          <v-dialog v-model="dialogInvoice" max-width="550px">
            <v-card>
              <v-card-title class="text-h5">Εκδοση Τιμολογίου Σύμβασης - <span class="font-bold">{{ editedItem.contract }}</span></v-card-title>
              <v-card-text>
                <v-container class="m-2">
                  <!-- <v-row>
                    <v-text-field label="Σύμβαση" v-model="editedItem.contract" readonly/>
                  </v-row> -->

                  <v-row>
                    <v-col>
                      <v-text-field label="Πελάτης" v-model="editedItem.customer" readonly/>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="col-8">
                      <v-select
                        v-model="editedItem.document_type_id"
                        v-bind:items="documentTypes"
                        item-text="description"
                        item-value="id"
                        label="Τύπος Παραστατικού"
                      />
                    </v-col>
                    
                    <v-col class="col-4">
                      <v-select
                        v-model="editedItem.document_series_id"
                        v-bind:items="selectedDocumentSeries"
                        item-text="name"
                        item-value="id"
                        label="Σειρά"
                        v-bind:disabled="editedItem.document_type_id == null"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="col-6">
                      <v-select
                        v-model="editedItem.payment_type_id"
                        v-bind:items="paymentTypes"
                        item-text="description"
                        item-value="id"
                        label="Τρόπος πληρωμής"
                      />
                    </v-col>
                    <v-col class="col-6">
                      <template>
                        <vuetify-money
                        label="Ποσό χρέωσης"
                        v-model="editedItem.amount"
                        v-bind:options="moneyFieldOptions" readonly
                        />
                        
                      </template>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col class="col-12">
                      <v-text-field
                      v-model="editedItem.override_description"
                      label="Περιγραφή χρέωσης"
                      disabled
                      />
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col class="col-12">
                      <v-text-field
                      v-model="editedItem.comments"
                      label="Σχόλια παραστατικου"
                      />
                    </v-col>

                  </v-row>

                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeInvoice">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="invoiceConfirm" v-bind:loading="invoiceButtonWorking" v-bind:disabled="invoiceButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="showInvoiceDialog(item)"> mdi-file-document </v-icon>
      </template>
    </v-data-table>
  </v-col>
    </v-row>

    <v-row>
      <v-col>
    
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="calories"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Συμβάσεις</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                ΠΡΟΣΘΗΚΗ
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Νέα Σύμβαση</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                      <v-text-field
                        v-model="editedItem.title"
                        label="Τίτλος σύμβασης"
                        v-bind:error-messages="allerrors.plates">
                      </v-text-field>
                      <v-autocomplete
                        label="Πελάτης"
                        v-model="editedItem.customer_id"
                        v-bind:items="customers"
                        item-text="name"
                        item-value="id"
                        clearable
                        v-bind:error-messages="allerrors.customer_id">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">

                    
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.start_date"
                                label="Ημερομηνία έναρξης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editedItem.start_date"
                            @input="menu1 = false">
                        </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="8" sm="6">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.end_date"
                                label="Ημερομηνία λήξης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                clearable>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editedItem.end_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>
                  </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                      <vuetify-money
                          label="Ποσό σύμβασης"
                          v-model="editedItem.total_amount"
                          v-bind:options="moneyFieldOptions">
                      </vuetify-money>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>              

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.title }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.start_date`]="{ item }">
        {{ formatDate(item.start_date) }}
      </template>
      <template v-slot:[`item.end_date`]="{ item }">
        {{ formatDate(item.end_date) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="{name: 'contractpage', params: {id: item.id}}"> 	
          <v-icon small class="mr-2"> mdi-pencil </v-icon>
        </router-link>

        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-col>

  </v-row>
  </div>
</template>

<script>
import { ToolbarItem } from "@syncfusion/ej2-vue-grids";
import axios from "axios";
import moment from "moment";
import { readonly } from "vue";

  export default {
    data: () => ({
      sortBy: ['scheduled_date'],
      sortDesc: [ false ],

      moneyFieldOptions: {
          locale: "el-GR",
          prefix: "€",
          suffix: "",
          length: 8,
          precision: 2
      },

      dialog: false,
      dialogDelete: false,

      dialogInvoice: false,
      
      
      headers2: [
        // {
        //   value: 'id',
        //   align: 'd-none'
        // },
        {
          text: 'Πελάτης',
          align: 'start',
          //sortable: false,
          value: 'customer',
        },
        {
          text: 'Σύμβαση',
          align: 'start',
          //sortable: false,
          value: 'contract',
        },
        {
          text: 'Ημερομηνία',
          align: 'start',
          //sortable: false,
          value: 'scheduled_date',
        },
        {
          text: 'Ποσό',
          align: 'right',
          //sortable: false,
          value: 'amount',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],

      documentTypes: [],
      documentSeries: [],

      paymentTypes: [],

      headers: [
        {
          text: 'Πελάτης',
          align: 'start',
          //sortable: false,
          value: 'customer.name',
        },
        {
          text: 'Τίτλος',
          align: 'start',
          //sortable: false,
          value: 'title',
        },
        { 
          text: 'Έναρξη', 
          value: 'start_date' 
        },
        { 
          text: 'Λήξη', 
          value: 'end_date' 
        },
        { 
          text: 'Ποσό', 
          value: 'total_amount' 
        },


        { text: 'Actions', value: 'actions', sortable: false },
      ],
      allerrors: [],
      items: [],
      customers: [],
      menu1: false,
      menu2: false,

      nextInvoices: [],

      editedIndex: -1,
      editedItem: {
        
      },
      defaultItem: {
        
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false,

      invoiceButtonWorking: false
    }),

    computed: {
      invoiceButtonDisabled() {
        if (this.editedItem == null)
          return true

        if (this.editedItem.document_type_id == null)
          return true

        if (this.editedItem.document_series_id == null)
          return true

        if (this.editedItem.payment_type_id == null)
          return true

        return false
      },

      selectedDocumentType() {
        return this.documentTypes.find(x => x.id == this.editedItem.document_type_id)
      },

      selectedDocumentSeries() {
        return this.selectedDocumentType?.series ?? []
      },

      invoiceInfoIncomplete() {
        return false
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },

      editedItemName () {
        return 'yay'
      },

      items2() {

        return this.nextInvoices.map(invoice => {
          let contract = this.items.find(x => x.id == invoice.contract_id)
            return {
              id: invoice.id,
              contract_id: contract.id,
              scheduled_date_iso: invoice.scheduled_date_iso,

              customer_id: contract.customer.id,
              customer: contract.customer.name,
              contract: contract.title,
              scheduled_date: invoice.scheduled_date ?? '',
              amount: invoice.amount ?? ''
            }
        })
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogInvoice (val) {
        val || this.closeInvoice()
      },

      selectedDocumentType(val) {
        if (val == null)
          return

        if (this.editedItem.override_description == null)
          this.editedItem.override_description = val.charges[0].description

        if (val.series.length == 1)
          this.editedItem.document_series_id = val.series[0].id
      },

    },

    

    created () {
      this.initialize()
    },

    methods: {

      customSort(items, sortBy, sortDesc) {

        const key = sortBy[0];
        const desc = sortDesc[0];

        return items.sort((a, b) => {
          let valA = a[key];
          let valB = b[key];

          // Handle dd/mm/yyyy dates
          if (key === 'scheduled_date') {
            const parseDate = (str) => {
              const [day, month, year] = str.split('/').map(Number);
              return new Date(year, month - 1, day);
            };
            valA = parseDate(valA);
            valB = parseDate(valB);

          }

          if (valA < valB) return desc ? 1 : -1;
          if (valA > valB) return desc ? -1 : 1;

          return 0;
        });
      },


      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      showInvoiceDialog(item) {
        this.editedItem = item;

        const contract = this.items.find(x => x.id == item.contract_id)


        // this.selectedDocumentType = this.documentTypes.find(x => x.id == item.suggested_document_type_id)
        

        this.editedItem.document_type_id = contract.suggested_document_type_id
        this.editedItem.document_series_id = contract.suggested_document_series_id
        this.editedItem.payment_type_id = contract.suggested_payment_type_id

        this.editedItem.override_description = `ΒΑΣΗ ΣΥΜΒΑΣΗΣ - ${contract.title}`


        this.dialogInvoice = true;
      },

      closeInvoice() {
        this.dialogInvoice = false;
        this.editedItem = {};
      },

      invoiceConfirm() {
        this.invoiceButtonWorking = true

        const request = {
          document_type_id: this.editedItem.document_type_id,
          document_series_id: this.editedItem.document_series_id,
          
          contract_id: this.editedItem.contract_id,
          customer_id: this.editedItem.customer_id,
          contract_invoice_schedule_id: this.editedItem.id,
          document_issue_date: moment().format('YYYY-MM-DD'),

          payment_type_id: this.editedItem.payment_type_id,
          amount: this.editedItem.amount,

          comments: this.editedItem.comments,
          
          charges: [
            {
              charge_type_id: this.selectedDocumentType.charges[0].id,
              override_description: this.editedItem.override_description,
              amount: this.editedItem.amount,
              gross_value: false
            }
          ]
        }

        axios.post('/api/contracts/invoice', request)
        .then(async response => { 
          const documentUuid = response.data.uuid

          await new Promise(r => setTimeout(r, 4000));

          window.open(`/invoices/pdf/${documentUuid}`, '_blank').focus();

          this.dialogInvoice = false

          this.initialize()
        })
        .catch(error => { 
          console.log(error)
        })
        .finally( () => { this.invoiceButtonWorking = false })
      },

      mixmatch(entry) {
        entry.customer = this.customers.find(customer => customer.id == entry.customer_id)
        return entry;
      },

      initialize () {
        axios.all([
          axios.get('/api/contracts'),
          axios.get('/api/contracts/next-invoices'),
          axios.get('/api/accounts'),
          axios.get('/api/document-types/service'),
          axios.get('/api/tax-authority/payment-types')
        ])
        .then(axios.spread((contractsResponse, nextInvoicesResponse, accountsResponse, documenetTypesResponse, paymentTypesResponse) => {
          this.nextInvoices = nextInvoicesResponse.data
          this.items = contractsResponse.data
          this.customers = accountsResponse.data
          this.documentTypes = documenetTypesResponse.data.filter(x => x.debit == true)
          this.paymentTypes = paymentTypesResponse.data
        }))
        .catch(error => { console.log(error) })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true;
        axios.delete(`/api/contracts/${this.items[this.editedIndex].id}`)
        .then(response => { this.initialize(); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.saveButtonDisabled = true;
        
        let requestBody = {
          customer_id: this.editedItem.customer_id,
          start_date: this.editedItem.start_date,
          end_date: this.editedItem.end_date,
          title: this.editedItem.title,
          total_amount: this.editedItem.total_amount
        }

        axios.post('/api/contracts', requestBody )
        .then(response => { this.initialize(); this.close(); })
        .catch(error => {
          console.log(error)
          
          this.saveButtonDisabled = false
        })
        .finally(() => this.saveButtonDisabled = false)
          
      },
    },
  }
</script>

<style>
</style>